import React from 'react'
import { AlertCircle } from 'lucide-react'
import { Card, CardContent } from '../ui/card'

const ErrorDisplay = ({ message, className = '' }) => {
  if (!message) return null

  return (
    <Card className={`border-red-200 bg-red-50 ${className}`}>
      <CardContent className="p-4">
        <div className="flex items-center space-x-2">
          <AlertCircle className="h-5 w-5 text-red-600" />
          <p className="text-red-800 font-medium">Error</p>
        </div>
        <p className="text-red-700 mt-1">{message}</p>
      </CardContent>
    </Card>
  )
}

export default ErrorDisplay
